import * as React from 'react';
import { Modal } from 'antd';

interface ConfirmModalProps {
    open: boolean;
    title: string;
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
    confirmText?: string;
    cancelText?: string;
    loading?: boolean;
    children?: React.ReactNode;
}

export function ConfirmModal({
    open,
    title,
    message,
    onConfirm,
    onCancel,
    confirmText = 'Yes',
    cancelText = 'Cancel',
    loading = false,
    children
}: ConfirmModalProps): React.ReactElement {
    const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth < 768);

    React.useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <Modal
            open={open}
            title={title}
            onOk={onConfirm}
            onCancel={onCancel}
            okText={confirmText}
            cancelText={cancelText}
            confirmLoading={loading}
            width={isMobile ? '90%' : 520}
            style={{ top: isMobile ? 20 : undefined }}
        >
            <p>{message}</p>
            {children}
        </Modal>
    );
}

